import { useQuery } from 'react-query';
import { getEmployeeUseCases } from '@personnel/composition';
import type { EmployeeDetailDto, EmployeeDetailRequestDto } from '@personnel/application/dtos';

/**
 * React Query hook to fetch a single employee by UUID.
 *
 * @param request - Employee detail query params (query disabled when undefined)
 * @returns Query result with employee detail
 */
export const useGetEmployeeByUuid = (request: EmployeeDetailRequestDto | undefined) => {
  const { getByUuid } = getEmployeeUseCases();

  return useQuery<EmployeeDetailDto>(
    ['personnel', 'employees', 'detail', request?.userUuid, request?.includeAssignedStores],
    () => getByUuid.execute(request!),
    {
      enabled: !!request?.userUuid,
    },
  );
};
